import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'

import { fetchOperators } from '../actions/operators'

import ErrorMessage from '../components/ErrorMessage'
import LoadingProgress from '../components/LoadingProgress'
import OperatorsList from '../components/OperatorsList'
import OperatorAddForm from '../forms/OperatorAddForm'
import '../styles/OperatorsView.css'

class OperatorsView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showAddModal: false
    }

    this.refreshOperators = this.refreshOperators.bind(this)
    this.toggleAddModal = this.toggleAddModal.bind(this)
  }

  componentDidMount() {
    this.props.fetchOperators()
  }

  refreshOperators() {
    this.props.fetchOperators()
  }

  toggleAddModal() {
    this.setState({ showAddModal: !this.state.showAddModal })
  }

  renderOperators() {
    const { operators, error, loading } = this.props

    if (error) {
      return (<ErrorMessage message={error.message} />)
    }

    if (!operators || loading) {
      return <LoadingProgress />
    }

    return (<OperatorsList operators={operators} />)
  }

  render() {
    const { role, type, category } = this.props
    const { showAddModal } = this.state

    return (
      <div className="operators-view">
        {/* Header Section */}
        <div className="operators-header">
          <div className="operators-title-section">
            <h1 className="operators-title">
              <i className="fas fa-handshake"></i>
              AGREGADORES
            </h1>
          </div>
          {((role === 'ADMIN' && (type === 'MASTER')) || category === 'BAQUEIRA') &&
            <div className="operators-actions">
              <button type="button" className="btn btn-vw btn-action" onClick={this.toggleAddModal}>
                <i className="fas fa-plus mr-2"></i>
                Nuevo
              </button>
            </div>
          }
        </div>

        {this.renderOperators()}

        {/* Add Operator Modal */}
        <Modal isOpen={showAddModal} toggle={this.toggleAddModal} size="lg" className="op-modal">
          <ModalHeader toggle={this.toggleAddModal}>
            <span className="text-vw-dark">AGREGADOR </span>
            <span className="text-vw-light">NUEVO</span>
          </ModalHeader>
          <ModalBody>
            <OperatorAddForm
              isModal={true}
              closeModal={this.toggleAddModal}
              refreshOperators={this.refreshOperators}
            />
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  operators: state.operators.operators,
  error: state.operators.error,
  loading: state.operators.loading,
  form: state.form,
  role: state.auth.role,
  type: state.auth.type,
  category: state.auth.category
})

const mapDispatchToProps = dispatch => ({
  fetchOperators: bindActionCreators(fetchOperators, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(OperatorsView)
